import React, { Component } from "react";
import "../../styles/ContainerCommon.css";
import "../../styles/Converter.css";
import "../../styles/switchbutton.css";
import { currentLocals } from "../../languages/languages.js";
import { ConvertTypes } from "../../Utilities/converterparamscnf.js";
import { ConvertTypesOut } from "../../Utilities/converterparamscnf.js";
import { MuiMenuIconButton, MuiMessageBox, MuiDialog, MuiLectraButton } from "@lectra/mui-library";
import { TextField, FormControl, FormLabel, Paper } from "@mui/material";
import Cookies from "universal-cookie";

export default class Converter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedConverterId: "",
      ConverterIdInProcessOfRenaming: "",
      ConverterIdReadOnly: true,
      converterId: this.props.converterId,
      error: false,
      helperText: "",
      askingDeleteConverter: false,
      askingRenameConverter: false,
    };

    // Bind the event handlers
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.stopDragOutsideZone = this.stopDragOutsideZone.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.ProcessFile = this.ProcessFile.bind(this);
    this.PreProcessFile = this.PreProcessFile.bind(this);
    this.UpdateConversionStatus = this.UpdateConversionStatus.bind(this);
    this.areFilesOfAllowedType = this.areFilesOfAllowedType.bind(this);
    this.isFileOfAllowedType = this.isFileOfAllowedType.bind(this);
    this.restoreUploadZoneBckgrnd = this.restoreUploadZoneBckgrnd.bind(this);
    this.setDragText = this.setDragText.bind(this);
    this.setDefaultDragText = this.setDefaultDragText.bind(this);
    this.setDefaultConverterText = this.setDefaultConverterText.bind(this);
    this.OpenConverterConfig = this.OpenConverterConfig.bind(this);
    this.DuplicateConverter = this.DuplicateConverter.bind(this);
    this.AskDeleteConverter = this.AskDeleteConverter.bind(this);
    this.handleRename = this.handleRename.bind(this);
    this.EnableRenameConverter = this.EnableRenameConverter.bind(this);
    this.ValidateRenameConverter = this.ValidateRenameConverter.bind(this);
    this.OnOkDelete = this.OnOkDelete.bind(this);
    this.OnCancelDelete = this.OnCancelDelete.bind(this);
    this.OnOkDoNothing = this.OnOkDoNothing.bind(this);
    this.OnDoNotShowAgain = this.OnDoNotShowAgain.bind(this);

    this.delay = this.delay.bind(this);
    this.StartAskingConversionStatus = this.StartAskingConversionStatus.bind(this);
    this.AskStatus = this.AskStatus.bind(this);
    this.sleep = this.sleep.bind(this);
    this.openPatternViewer = this.openPatternViewer.bind(this);
    this.ProccesFileList = this.ProccesFileList.bind(this);
    this.IntervalAskStatus = 3000;
    this.ConversionTimeOut = 60;
    this.AskStatusTimer = 0;
  }

  state = {
    bIsDraggingInUploadZone: "",
    bShowWarningMdlV7: false,
  };

  handleDragStart(idx) {
    this.props.OnDragging(this.props.converterId);
  }
  handleDragEnter(event) {
    // highlight potential drop target when the draggable element enters it
    if (event.target.className.includes("uploadzone")) {
      this.setState({ bIsDraggingInUploadZone: true });
    } else {
      this.stopDragOutsideZone(event);
    }
  }
  handleDragLeave(event) {
    // reset background of potential drop target when the draggable element leaves it
    if (event.target.className.includes("uploadzone")) {
      this.setState({ bIsDraggingInUploadZone: false });
    } else {
      this.stopDragOutsideZone(event);
    }
  }

  handleDragOver(event) {
    if (event.target.className.includes("uploadzone")) {
      event.preventDefault();
      this.setState({ bIsDraggingInUploadZone: true });
    } else {
      this.setState({ bIsDraggingInUploadZone: false });
      this.stopDragOutsideZone(event);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // only update if the data has changed
    if (prevState.bIsDraggingInUploadZone !== this.state.bIsDraggingInUploadZone) {
      if (this.state.bIsDraggingInUploadZone) {
        let dragTarget = document.getElementById("uploadzone" + this.props.converterId);

        if (dragTarget) {
          dragTarget.className = "uploadzone uploadzoneHover";
        }
      } else {
        this.restoreUploadZoneBckgrnd();
      }
    }
  }

  stopDragOutsideZone(event) {
    event.preventDefault();
    event.dataTransfer.effectAllowed = "none";
  }

  areFilesOfAllowedType(listFiles) {
    // files is not an array, but a FileList. So, we’ll need to convert it to an array
    // in order to iterate over it more easily:
    let arrfiles = [...listFiles];

    for (let nFileCounter = 0; nFileCounter < arrfiles.length; nFileCounter++) {
      if (!this.isFileOfAllowedType(arrfiles[nFileCounter])) {
        return false;
      }
    }

    return true;
  }

  isFileOfAllowedType(file) {
    let bAllowed = false;

    switch (this.props.convertertype) {
      case "accumark": {
        if (
          //always is a zip file...
          file.type === "application/zip" ||
          file.type === "application/octet-stream" ||
          file.type === "application/x-zip-compressed" ||
          file.type === "multipart/x-zip"
        )
          bAllowed = true;
        break;
      }
      case "aama_astm": {
        let extension = file.name.split(".").pop().toLowerCase();
        if (extension === "dxf" || extension === "rul") bAllowed = true;
        break;
      }
      case "dxf": {
        let extension = file.name.split(".").pop().toLowerCase();
        if (extension === "dxf") bAllowed = true;
        break;
      }
      case "mdl": {
        let extension = file.name.split(".").pop().toLowerCase();
        if (extension === "mdl") bAllowed = true;
        break;
      }
      default:
        bAllowed = false;
    }
    return bAllowed;
  }

  restoreUploadZoneBckgrnd() {
    let dragTarget = document.getElementById("uploadzone" + this.props.converterId);

    if (dragTarget) {
      if (
        this.props.converterInOut === "In" ||
        this.props.convertertype === "accumark" ||
        this.props.convertertype === "aama_astm"
      )
        dragTarget.className = "uploadzone  " + this.props.convertertype;
      else if (this.props.ConversionTimeOut === "Out" || this.props.convertertype === "mdl")
        dragTarget.className = "uploadzone  " + this.props.convertertypedestination;
    }
  }

  setDragText(text, isError) {
    let dragTextElement = document.getElementById("dragtext" + this.props.converterId);
    if (dragTextElement) {
      dragTextElement.innerHTML = text;
      dragTextElement.className = isError ? "dragtext dragtextError" : "dragtext";
    }
  }

  setDefaultConverterText() {
    let typeFilesToConvert = [" (.zip)", " (.dxf)", " (.mdl)", " (.dxf)"];
    let typeFiles;

    let sConverterText;

    const locals = currentLocals(this.props.locale);
    //const arrow = "  \u{1F8A7}  ";
    switch (this.props.convertertype) {
      case "accumark":
        typeFiles = typeFilesToConvert[0];
        break;
      case "aama_astm":
        typeFiles = typeFilesToConvert[1];
        break;
      case "mdl":
        typeFiles = typeFilesToConvert[2];
        break;
      case "dxf":
        typeFiles = typeFilesToConvert[3];
        break;
      default:
        sConverterText += "";
    }

    let data = { 0: typeFiles };
    const replaceVariables = (match, inner) => {
      return data[inner] || "";
    };
    /* How to use this */
    //sConverterText = locals.converter.DragAndDropFile.replace(/\$\{(\w+)\}/gi, replaceVariables);
    sConverterText = locals.converter.DragAndDropFile + "" + typeFiles;

    return sConverterText;
  }
  setDefaultDragText() {
    const locals = currentLocals(this.props.locale);
    //const arrow = "  \u{1F8A7}  ";
    switch (this.props.convertertype) {
      case "accumark":
        this.setDragText(locals.converter.DragAndDrop + " " + locals.converter.file + " Accumark .zip", false);
        break;
      case "aama_astm":
        this.setDragText(locals.converter.DragAndDrop + " " + locals.converter.file + " AAMA ASTM .dxf", false);
        break;
      case "mdl":
        this.setDragText(locals.converter.DragAndDrop + " " + locals.converter.file + " .mdl", false);
        break;
      case "dxf":
        this.setDragText(locals.converter.DragAndDrop + " " + locals.converter.file + " .dxf", false);
        break;
      default:
        this.setDragText(locals.converter.DragAndDrop + " " + locals.converter.file + "", false);
    }
  }
  setFileAllowedText() {
    switch (this.props.convertertype) {
      case "accumark":
        this.setDragText("Only accumark .zip files", true);
        break;
      case "aama_astm":
      case "dxf":
        this.setDragText("Only .dxf files", true);
        break;
      case "mdl":
        this.setDragText("Only .mdl files", true);
        break;
      default:
        this.setDragText("files", true);
    }
  }

  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  UpdateConversionStatus(conversion) {
    const { getConversionStatus, conversions, updateStoreConversionStatus, updateStoreConversionStatusDescription } =
      this.props;

    let Converter = document.getElementById("uploadzone" + conversion.converter);
    let UploadZoneInnerBox = document.getElementById("uploadzoneinnerbox" + conversion.converter);
    //if current status is Done or timeOut or ko, stop
    if (
      conversion.status === "Done" ||
      conversion.status === "TimeOut" ||
      conversion.status === "ko" ||
      conversion.status === "Error_on_CAD_Data_send"
    ) {
      if (conversion.status === "Done") {
        let viewMDLData = document.getElementById("View_" + conversion.id);
        viewMDLData.style.visibility = "visible";
        viewMDLData.style.opacity = "0.4";
        viewMDLData.setAttribute("bopenmdlviewer", false);

        let downMDL = document.getElementById("DownLoad_" + conversion.id);
        if (downMDL !== null) downMDL.style.visibility = "visible";
      }

      // Process is finished ; Done, TimeOut, ko, or Error_on_CAD_Data_send
      //Converter.classList.remove("processing");
      //Converter.classList.add("stopped");
      UploadZoneInnerBox.classList.remove("processing");
      UploadZoneInnerBox.classList.add("stopped");
      //Converter.classList.add(conversion.type);
      return;
    }

    getConversionStatus({
      id: conversion.id,
      type: conversion.type,
      datain: conversion.datain,
      dataout: conversion.dataout,
    });

    let status = conversion.status;
    for (let i = 0; i < conversions.length; i++) {
      if (conversions[i].id === conversion.id) {
        status = conversions[i].status;
        break;
      }
    }

    //let processingTime = (Date.now() - parseInt(conversion.id, 10)) / 1000;
    let idData = conversion.id.split("_");
    let startDate = idData[0];
    let processingTime = (Date.now() - parseInt(startDate, 10)) / 1000;

    if (processingTime > this.ConversionTimeOut) {
      status = "TimeOut";
      let description = "TimeOut";
      // Process is Timeout: Stopped
      //Converter.classList.remove("processing");
      //Converter.classList.add("stopped");
      UploadZoneInnerBox.classList.remove("processing");
      UploadZoneInnerBox.classList.add("stopped");

      updateStoreConversionStatus({ id: conversion.id, status: status });
      updateStoreConversionStatusDescription({
        id: conversion.id,
        status: status,
        description: description,
      });
    } else {
      // Process is still ongoing
      //Converter.classList.add("processing");
      //Converter.classList.remove("stopped");
      UploadZoneInnerBox.classList.add("processing");
      UploadZoneInnerBox.classList.remove("stopped");

      conversion.status = status;
      this.sleep(this.IntervalAskStatus).then(() => {
        this.UpdateConversionStatus(conversion);
      });
    }
  }
  openPatternViewer() {
    let PatternViewer = document.getElementById("PatternViewer");
    PatternViewer.style.display = "flex";
  }

  ProcessFile(file, arrfiles) {
    const extension = file.name.split(".").pop();
    if (extension.toLowerCase() === "rul") return;

    // Control if show warning for mdl v7 conversion

    if (this.props.convertertype === "mdl") {
      const cookies = new Cookies();
      let notShowWarningMdlV7Again = cookies.get("notShowWarningMdlV7Again");
      if (notShowWarningMdlV7Again === undefined) notShowWarningMdlV7Again = "0";
      //alert(notShowWarningMdlV7Again);
      if (notShowWarningMdlV7Again === "0") {
        this.setState({ bShowWarningMdlV7: true });
      } else {
        this.setState({ bShowWarningMdlV7: false });
      }
    }

    //Add conversion
    let DateNow = Date.now().toString();
    let UniqueId = DateNow + "_" + file.name;
    //to have different id when multidrop
    let date = new Date(parseInt(DateNow, 10));

    let fdate = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
    let dataout;

    if (this.props.typeInOut === "In") {
      if (this.props.convertertype !== "mdl") dataout = file.name.replace("." + extension, ".mdl");
      else dataout = file.name.replace("." + extension, ".zip");
    } //(this.prop.typeInOut="Out"
    else {
      if (this.props.convertertypedestination === "mdl_V7") dataout = file.name.replace("." + extension, "_V7.mdl");
      if (this.props.convertertypedestination === "dxf_extended") dataout = file.name.replace("." + extension, ".zip");
    }

    let conversion = {
      id: UniqueId,
      date: fdate,
      user: this.props.user,
      datain: file.name,
      dataout: dataout,
      converter: this.props.converterId,
      type: this.props.convertertype,
      typeOut: this.props.convertertypedestination,
      status: "Sent",
      description: "DefaultDescription",
    };

    const { addConversion, processConversion } = this.props;

    //this.UpdateConversionStatus(conversion);
    if (extension.toLowerCase() === "dxf") {
      this.ManageDXFConversion(arrfiles, file, conversion);
    } else {
      addConversion(conversion);
      processConversion({ file, conversion });
    }
    return conversion;
  }

  delay(duration) {
    const promise = new Promise((resolve) => {
      setTimeout(() => resolve(true), duration);
    });
    return promise;
  }

  PreProcessFile(file, arrfiles) {
    //  it is neccessary to declare, in this way, the functions we're going
    // to call
    const { preProcessConversion } = this.props;
    let user = this.props.user;
    let converterId = this.props.converterId;
    let convertertype = this.props.convertertype;
    preProcessConversion({ file, user, converterId, convertertype });
  }
  AskStatus() {
    //console.log("Function AskStatus of Component");
    const { conversions, getConversionStatus, updateConversionStatus } = this.props;
    let PendingToFinish = false;
    let nConversionesPendientes = 0;
    let nConversionesPreguntadas = 0;
    //console.log("conversions.length " + conversions.length);
    /* for (let j = 0; j < conversions.length; j++) {
      let conversion = conversions[j];
      if (conversion.status === "Sent" || conversion.status === "in_convertion") {
        nConversionesPendientes++;
      }
    }
    */
    //console.log("conversiones pendientes " + nConversionesPendientes);
    for (let i = 0; i < conversions.length; i++) {
      let conversion = conversions[i];
      if (conversion.status === "Sent" || conversion.status === "in_convertion") {
        PendingToFinish = true;
        getConversionStatus(conversion);
        nConversionesPreguntadas++;
      }
    }
    console.log("conversiones preguntadas " + nConversionesPreguntadas);

    //yield put(stopAskingConversionStatus(Timer));

    // All conversion processed then stop asking.
    if (PendingToFinish === false) {
      clearInterval(this.AskStatusTimer);
      const Mode = this.getUrlParam("mode", "InOut");
      //when all covsersion processded  then stop all converters
      const converters = this.props.converters;
      converters.forEach((converter) => {
        let uploadzoneConverter = document.getElementById("uploadzone" + converter.id);
        let uploadzoneinnerboxConverter = document.getElementById("uploadzoneinnerbox" + converter.id);
        /*Only remove fron classList on converters visibles  In, Out...*/
        if (
          (converter.typeInOut === "In" && (Mode === "In" || Mode === "InOut")) ||
          (converter.typeInOut === "Out" && (Mode == "Out" || Mode === "InOut"))
        ) {
          // Test if converter is active (is is possible that "old converters exist on azzure eg, dxf_extended")
          if (converter.typeInOut === "In" && ConvertTypes.indexOf(converter.type) >= 0) {
            //uploadzoneConverter.classList.remove("processing");
            //uploadzoneConverter.classList.add("stopped");
            uploadzoneinnerboxConverter.classList.remove("processing");
            uploadzoneinnerboxConverter.classList.add("stopped");
          }
          if (converter.typeInOut === "Out" && ConvertTypesOut.indexOf(converter.typeDestination) >= 0) {
            //uploadzoneConverter.classList.remove("processing");
            //uploadzoneConverter.classList.add("stopped");
            uploadzoneinnerboxConverter.classList.remove("processing");
            uploadzoneinnerboxConverter.classList.add("stopped");
          }
        }
      });
    }
  }
  StartAskingConversionStatus() {
    console.log(">>>>>>>>>>>>>>this.AskStatusTimer = setInterval(this.AskStatus, this.IntervalAskStatus);");
    this.AskStatusTimer = setInterval(this.AskStatus, this.IntervalAskStatus);
  }
  handleDrop(event, bIsMultipleMdl) {
    const Connected = this.getUrlParam("connected", "No");
    // Stop default handling of dropped file. preventDefault is a javascrip default
    // function that prevents open a file, print....

    /*     if (this.props.convertertype === "mdl") {
      this.setState({ bShowWarningMdlV7: true });
    } */

    event.preventDefault();
    let OnlyOneFileAtTime = this.props.onlyOneFileAtTime;
    /*
    if (OnlyOneFileAtTime) alert("Solo uno");
    else alert("Más de lo uno");*/
    // move dragged elem to the selected drop target

    let arrfilesAux = Array.from(event.dataTransfer.files);
    let noPermitirConversionPorNumFicheros = false;
    if (arrfilesAux.length > 1 && OnlyOneFileAtTime) {
      /* Case PCONV_STANDALONE
      Accumark; solo permitimos UNO
      aama_astm; pueden ser más de uno, el DXF y varios RUL, pero solo un DXF*/
      let nNumDxf = 0;
      if (event.target.className.includes("uploadzone")) {
        this.restoreUploadZoneBckgrnd(); //change colour and other visual effects
      }
      if (this.props.convertertype === "aama_astm") {
        arrfilesAux.forEach((file, ...arrfilesAux) => {
          let extension = file.name.split(".").pop().toLowerCase();
          if (extension === "dxf") nNumDxf++;
        });
        if (nNumDxf > 1) noPermitirConversionPorNumFicheros = true;
      } else noPermitirConversionPorNumFicheros = true; //accumark, mdl7...
      //this.stopDragOutsideZone(event);
      //return;
    }
    if (noPermitirConversionPorNumFicheros) {
      alert(currentLocals(this.props.locale).converter.OnlyOneFileAtTime);
    } else {
      if (event.target.className.includes("uploadzone")) {
        this.restoreUploadZoneBckgrnd(); //change colour and other visual effects

        if (this.areFilesOfAllowedType(event.dataTransfer.files)) {
          ///

          if (this.props.convertertype === "dxf") {
            //open CAD wizard
            //this.openPatternViewer();
            return;
          }
          //
          let ConverterInUse = document.getElementById("uploadzone" + this.props.converterId);
          //ConverterInUse.classList.add("processing");
          let UploadZoneInnerBox = document.getElementById("uploadzoneinnerbox" + this.props.converterId);
          UploadZoneInnerBox.classList.add("processing");

          let ConversionInUse;
          if (bIsMultipleMdl && this.props.convertertype === "accumark") {
            let arrfiles = Array.from(event.dataTransfer.files);
            const fileCount = arrfiles.length;
            arrfiles.forEach((file, ...arrfiles) => {
              this.PreProcessFile(file, arrfiles);
            });
          } else {
            let arrfiles = Array.from(event.dataTransfer.files);
            const fileCount = arrfiles.length;
            let timeOut = 6000 + fileCount * 5; // 5 seconds por file
            this.ConversionTimeOut = timeOut;
            arrfiles.forEach((file, ...arrfiles) => {
              ConversionInUse = this.ProcessFile(file, arrfiles);
            });
          }
        } else {
          this.setFileAllowedText();
          setTimeout(this.setDefaultDragText, 2000);
        }
      } else {
        this.stopDragOutsideZone(event);
      }
    }

    //const { startAskingConversionStatus } = this.props;
    // saga Function:startAskingConversionStatus();
    // This Component function
    this.StartAskingConversionStatus();
  }

  handleClick(event, bIsMultipleMdl) {
    const Connected = this.getUrlParam("connected", "No");
    // Stop default handling of dropped file. preventDefault is a javascrip default
    // function that prevents open a file, print....

    if (this.props.typeInOut === "In") {
      let inputfake = document.getElementById("inputfake" + this.props.converterId);

      if (bIsMultipleMdl) inputfake.setAttribute("multiple", "");
      else inputfake.setAttribute("multiple", "");
      if (this.props.convertertype === "accumark") inputfake.setAttribute("accept", ".zip");
      if (this.props.convertertype === "aama_astm") inputfake.setAttribute("accept", ".dxf,.rul");

      window.document.body.appendChild(inputfake);

      var arrfiles;
      inputfake.onchange = (_) => {
        // you can use this method to get file and perform respective operations

        let files = inputfake.files;
        let i = 0;
        this.ProccesFileList(files, bIsMultipleMdl);
        this.StartAskingConversionStatus();
      };

      inputfake.click();

      //window.document.body.removeChild(inputfake);
    } else if (this.props.typeInOut === "Out") {
      let inputfake = window.document.createElement("input");
      inputfake.setAttribute("type", "file");
      inputfake.style.display = "none";
      if (this.props.convertertype === "mdl") inputfake.setAttribute("accept", ".mdl");
      window.document.body.appendChild(inputfake);
      var arrfiles;
      inputfake.onchange = (_) => {
        // you can use this method to get file and perform respective operations
        //arrfiles = Array.from(inputfake.files);

        let files = inputfake.files;
        let i = 0;
        this.ProccesFileList(files, bIsMultipleMdl);
        this.StartAskingConversionStatus();
      };
      inputfake.click();
      window.document.body.removeChild(inputfake);

      /*
      if (this.props.convertertype === "mdl") {
         this.setState({ bShowWarningMdlV7: true });
      }*/
    } else return;
  }

  ProccesFileList = (files, bIsMultipleMdl) => {
    this.restoreUploadZoneBckgrnd(); //change colour and other visual effects

    if (this.areFilesOfAllowedType(files)) {
      ///
      if (this.props.convertertype === "dxf") {
        //open CAD wizard
        //this.openPatternViewer();
        return;
      }
      //  //  //  //  //  //

      let ConverterInUse = document.getElementById("uploadzone" + this.props.converterId);
      //ConverterInUse.classList.add("processing");
      let UploadZoneInnerBox = document.getElementById("uploadzoneinnerbox" + this.props.converterId);
      UploadZoneInnerBox.classList.add("processing");

      let ConversionInUse;

      if (bIsMultipleMdl && this.props.convertertype === "accumark") {
        let arrfiles = Array.from(files);
        const fileCount = arrfiles.length;
        arrfiles.forEach((file, ...arrfiles) => {
          this.PreProcessFile(file, arrfiles);
        });
      } else {
        let arrfiles = Array.from(files);
        const fileCount = arrfiles.length;
        let timeOut = 6000 + fileCount * 5; // 5 seconds por file
        this.ConversionTimeOut = timeOut;

        arrfiles.forEach((file, ...arrfiles) => {
          ConversionInUse = this.ProcessFile(file, arrfiles);
        });
      }
    } else {
      this.setFileAllowedText();
      setTimeout(this.setDefaultDragText, 2000);
    }
  };
  ManageDXFConversion = (arrfiles, file, conversion) => {
    const { addConversion, processConversion } = this.props;
    let text = "";

    const extension = file.name.split(".").pop();
    let reader = new FileReader();
    reader.onload = function (e) {
      // get file content

      // INICIO; Verify if file is isUtf8

      // npm install detect-file-encoding-and-language
      /*
      const languageEncoding = require("detect-file-encoding-and-language");
      const fileToDetect = file;
      languageEncoding(fileToDetect).then((fileInfo) => console.log(fileInfo));
      */
      /*
      BufferedReader in = new BufferedReader(new InputStreamReader(new FileInputStream(fileName), "UTF-8"));
      PrintWriter(new out = new PrintWriter(new OutputStreamWriter(new FileOutputStream(newFileName), "UTF-8"));
      fString line; 
      while ((line = in.readLine()) != null; ) {
          // do some processing with line, and then:
          out.println(line);
      }
      out.close();
      in.close();
      */

      // FINAL; Verify if file is isUtf8
      text = e.target.result;

      let rulfile0 = GetRuleFile(text, file, "Grade Rule Table:", arrfiles);
      let rulfile1 = GetRuleFile(text, file, "Special Grade Rule Table 1:", arrfiles);
      let rulfile2 = GetRuleFile(text, file, "Special Grade Rule Table 2:", arrfiles);
      let rulfile3 = GetRuleFile(text, file, "Special Grade Rule Table 3:", arrfiles);

      let arrrulfiles = [];
      if (rulfile0 !== null) arrrulfiles.push(rulfile0);
      if (rulfile1 !== null) arrrulfiles.push(rulfile1);
      if (rulfile2 !== null) arrrulfiles.push(rulfile2);
      if (rulfile3 !== null) arrrulfiles.push(rulfile3);

      addConversion(conversion);
      processConversion({ file, arrrulfiles, conversion });
    };
    reader.readAsText(file);
  };

  handleChangeType = (event, id, typeInOut) => {
    const { updateConverterType } = this.props;
    //let newtype=event.target[0].label;
    let newtype = event.target.value;

    updateConverterType({
      id: id,
      type: event.target.value,
      typeInOut: typeInOut,
    });
    // We change also the selected  converter rtype on ConverterManagerPool
    let DropDownTypes = document.getElementById("DropDownTypes" + id);
    DropDownTypes.value = newtype;
  };
  handleChangeMultipleMdl = (event, id) => {
    const { updateConverterMultipleMdl } = this.props;
    updateConverterMultipleMdl({ id: id, multiplemdl: event.target.checked });
  };

  handleEdit = (event, id) => {
    let editstatus = document.getElementById("editStatus" + this.props.converterId);
    let converterId = document.getElementById("converterId" + this.props.converterId);
    let configuration = document.getElementById("configuration_" + this.props.converterId);
    let value = editstatus.textContent.toString();
    let toUpdate = String.fromCharCode(parseInt(10003, 10));
    let toEdit = String.fromCharCode(parseInt(9998, 10));

    if (value === toEdit) {
      editstatus.textContent = toUpdate;
      converterId.removeAttribute("readOnly");
      converterId.style.color = "black";
      converterId.style.backgroundColor = "white";
      converterId.focus();
      configuration.style.visibility = "visible";
    } else {
      const { updateConverterId } = this.props;
      let newid = converterId.value;

      if (id !== newid) {
        const converters = this.props.converters;

        let exist = converters.findIndex((converter) => converter.id === newid) > 0;

        if (exist === true) {
          alert(currentLocals(this.props.locale).converter.already_exist + " " + newid);
          return;
        }
        updateConverterId({ id: id, newid: newid });
      }

      converterId.readOnly = "true";
      converterId.style.color = "";
      converterId.style.backgroundColor = "";
      editstatus.textContent = toEdit;
      configuration.style.visibility = "hidden";
    }
  };

  OpenConverterConfig() {
    if (this.props.convertertype !== "accumark") return;
    const { setConverterOnEdition, setConverterConfigOpen, getConverterConfig } = this.props;

    setConverterOnEdition(this.props.converterId);
    setConverterConfigOpen(true);

    getConverterConfig({
      id: this.props.converterId,
      type: this.props.convertertype,
    });
  }
  DuplicateConverter() {
    const { copyConverter, converters } = this.props;
    //const { currentDragging } = this.state;
    let currentDragging = this.props.converterId;

    const index = converters.findIndex((converter) => converter.id === currentDragging);
    if (index >= 0) {
      const type = converters[index].type;
      const typeDestination = converters[index].typeDestination;
      const typeInOut = converters[index].typeInOut;
      copyConverter({ id: currentDragging, type, typeDestination, typeInOut });
    }
  }
  AskDeleteConverter() {
    //Shows the MessageBox
    this.setState({ askingDeleteConverter: true });
    /*
    if (window.confirm(currentLocals(this.props.locale).converter.sure_to_delete + currentDragging.toUpperCase())) {
      removeConverter({ id: currentDragging });
    }*/
  }

  OnOkDelete() {
    const { removeConverter } = this.props;
    this.setState({ askingDeleteConverter: false });
    removeConverter({ id: this.props.converterId });
  }
  OnCancelDelete() {
    this.setState({ askingDeleteConverter: false });
  }

  OnOkDoNothing() {
    this.setState({ bShowWarningMdlV7: false });
    //const cookies = new Cookies();
    //cookies.set("notShowWarningMdlV7Again", "0", { path: "/" });
  }
  OnDoNotShowAgain() {
    this.setState({ bShowWarningMdlV7: false });
    const cookies = new Cookies();
    cookies.set("notShowWarningMdlV7Again", "1", { path: "/" });
  }

  AskRenameConverter() {
    this.setState({ askingRenameConverter: true });
    let idConverterInput = "converterId" + this.props.converterId;
    //let idConverterValidate = "validaterename_" + this.props.converterId;
    this.setState({ ConverterIdInProcessOfRenaming: this.props.converterId });

    document.getElementById(idConverterInput).readOnly = true;
    this.setState({ ConverterIdReadOnly: false });

    //document.getElementById(idConverterInput).focus();
    //document.getElementById(idConverterValidate).style.visibility = "visible";
  }
  OnOkRename(newConverterId) {
    this.ValidateRenameConverter(newConverterId);
    this.setState({ askingRenameConverter: false });
  }
  OnCancelRename() {
    this.setState({
      converterId: this.state.ConverterIdInProcessOfRenaming,
      askingRenameConverter: false,
      error: false,
      helperText: "",
    });
  }

  EnableRenameConverter() {
    let idConverterInput = "converterId" + this.props.converterId;
    //let idConverterValidate = "validaterename_" + this.props.converterId;
    this.setState({ ConverterIdInProcessOfRenaming: this.props.converterId });

    document.getElementById(idConverterInput).readOnly = false;
    this.setState({ ConverterIdReadOnly: false });

    //document.getElementById(idConverterInput).focus();
    //document.getElementById(idConverterValidate).style.visibility = "visible";
  }

  handleRename = (newconverterid) => {
    let bError = false;
    let bExist = false,
      bEmptyName = false;
    let sErrorInfo = "";

    if (newconverterid === "") {
      bError = true;
      bEmptyName = true;
    }
    if (!bError) {
      let converters = this.props.converters;
      let i = 0;

      while (i < converters.length && !bExist) {
        if (converters[i].id === newconverterid && this.props.converterId !== newconverterid) {
          bError = true;
          bExist = true;
        }
        i++;
      }
    }
    if (bError) {
      if (bExist)
        sErrorInfo =
          String.fromCharCode(parseInt(10811, 10)) +
          "  " +
          currentLocals(this.props.locale).converter.ConverterNameExist;
      if (bEmptyName)
        sErrorInfo =
          String.fromCharCode(parseInt(10811, 10)) +
          "  " +
          currentLocals(this.props.locale).converter.ConverterNameIsEmpty;
      this.setState({ converterId: newconverterid, error: true, helperText: sErrorInfo });
    } else {
      this.setState({ converterId: newconverterid, error: false, helperText: "" });
    }
  };
  ValidateRenameConverter = (newconverterid) => {
    let idConverter = "converterId" + this.props.converterId;
    let converters = this.props.converters;
    const updateConverterId = this.props.updateConverterId;
    let bReturn = true;
    let sInfoValidation;
    if (this.state.ConverterIdInProcessOfRenaming === "") bReturn = false;
    else {
      if (newconverterid === "") {
        sInfoValidation = currentLocals(this.props.locale).converter.ConverterNameIsEmpty;
        alert(sInfoValidation);
        bReturn = false;
      } else if (newconverterid === this.props.converterId) {
        sInfoValidation = "no cambia";
        //alert(sInfoValidation);
        bReturn = true;
      } else {
        //Test if new name exists
        let i = 0;
        let bExiste = false;
        while (i < converters.length && !bExiste) {
          if (converters[i].id === newconverterid) bExiste = true;
          i++;
        }
        if (bExiste) {
          //this.ReadConverters();

          if (this.state.ConverterIdInProcessOfRenaming === newconverterid) {
            sInfoValidation = currentLocals(this.props.locale).converter.ConverterNameExist;
            alert(sInfoValidation + ". " + newconverterid);
          }
          bReturn = false;
        } else {
          updateConverterId({ id: this.props.converterId, newid: newconverterid });
          this.setState({ ConverterIdEditable: false });
          bReturn = true;
        }
      }
    }
    this.setState({ ConverterIdInProcessOfRenaming: "" });
    document.getElementById(idConverter).readOnly = true;
    //document.getElementById("validaterename_" + this.props.converterId).style.visibility = "hidden";
    return bReturn;
  };

  getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }
  getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
      urlparameter = this.getUrlVars()[parameter];
    }
    return urlparameter;
  }

  render() {
    const Connected = this.getUrlParam("connected", "No");
    const renderFileSelectionMode = () => {
      /*
      http://localhost:3000/?mode=Import&connected=Yes
      http://localhost:3000/?mode=Output&connected=Yes
      http://localhost:3000/?mode=ImportOutput&connected=Yes
      */
      //alert(Mode);
      if (Connected === "Yes") return <div onClick={(event) => this.handleClick(event, isMultipleMdl)}></div>;
      else return <div onDrop={(event) => this.handleDrop(event, isMultipleMdl)}></div>;
    };

    let isMultipleMdl = false;
    const arrow = "  \u{1F8A7}  ";
    const converters = this.props.converters;
    const index = converters.findIndex((converter) => converter.id === this.props.converterId);
    if (index >= 0) {
      isMultipleMdl = converters[index].multiplemdl;
      if (this.props.convertertype === "aama_astm") isMultipleMdl = false;
      if (this.props.convertertype === "accumark") {
        isMultipleMdl = converters[index].multiplemdl;
        if (!isMultipleMdl) isMultipleMdl = false;
      }

      // If it is not true, it is false (in the case of converters created before the multiplicity attribute appears)
      if (!isMultipleMdl) isMultipleMdl = false;
    }
    let typeToShow;
    if (this.props.typeInOut === "In") {
      typeToShow = this.props.convertertype;
    }
    if (this.props.typeInOut === "Out") {
      typeToShow = this.props.convertertypedestination;
    }

    let ConverterDescription = "";
    /*            {` ${this.props.convertertype}`}
            {`  ${arrow}`} {` ${this.props.convertertypedestination}`}*/

    let EnabledDxfextended = window.document.getElementById("dxf-extended-exist");
    //deleted dxf extended on tile desciption
    if (this.props.convertertype === "accumark") ConverterDescription = "accumark " + arrow + " mdl";
    if (this.props.convertertype === "aama_astm") {
      if (EnabledDxfextended !== null) ConverterDescription = "aama/astm " + arrow + " mdl";
      else ConverterDescription = "aama/astm " + arrow + " mdl";
    }
    if (this.props.convertertypedestination === "dxf_extended") ConverterDescription = "mdl " + arrow + " dxf_extended";
    if (this.props.convertertypedestination === "mdl_V7") ConverterDescription = "mdl " + arrow + " mdl_V7";

    let actionsMuiMenuIconButton;
    if (this.props.convertertype === "accumark")
      actionsMuiMenuIconButton = [
        {
          //action: (event) => this.EnableRenameConverter(this.props.converterId),
          action: (event) => this.AskRenameConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerRename,
        },
        {
          action: (event) => this.OpenConverterConfig(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerConfiguration,
        },
        {
          action: (event) => this.DuplicateConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerDuplicate,
        },
        {
          action: (event) => this.AskDeleteConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerDelete,
        },
      ];
    else
      actionsMuiMenuIconButton = [
        {
          //action: (event) => this.EnableRenameConverter(this.props.converterId),
          action: (event) => this.AskRenameConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerRename,
        },
        {
          action: (event) => this.DuplicateConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerDuplicate,
        },
        {
          action: (event) => this.AskDeleteConverter(this.props.converterId),
          label: currentLocals(this.props.locale).converter.ConverterManagerDelete,
        },
      ];

    const renderMuiMenuIconButton = () => {
      if (!this.props.enableCRUD)
        return (
          <MuiMenuIconButton
            style={{ display: "none", fontSize: 4, zIndex: "1" }}
            actions={actionsMuiMenuIconButton}
            disabled
          />
        );
      else {
        if (this.props.convertertype === "accumark") {
          return (
            <MuiMenuIconButton
              style={{ display: "grayed", fontSize: 4, zIndex: "1" }}
              actions={actionsMuiMenuIconButton}
            />
          );
        } else
          return (
            <MuiMenuIconButton
              style={{ display: "grayed", fontSize: 4, zIndex: "1" }}
              actions={actionsMuiMenuIconButton}
            />
          );
      }
    };
    let miConverterIdReadOnly = this.state.ConverterIdReadOnly;
    return (
      <Paper
        className={`uploadcontainer`}
        onDragStart={this.handleDragStart}
        onDragOver={this.handleDragOver}
        onDragEnter={this.handleDragEnter}
        onDragLeave={this.handleDragLeave}
        data-tut="reactour__converter"
        elevation={2}
      >
        <div>
          <div className={`${typeToShow}`}>
            <input
              id={`inputfake${this.props.converterId}`}
              type="file"
              style={{ visibility: "hidden", display: "none" }}
            ></input>
            <div className={`convertername ${typeToShow}`}>
              <FormLabel
                id={`converterId${this.props.converterId}`}
                style={{
                  paddingTop: "2px",
                  paddingLeft: "10px",
                  height: "29px",
                  width: "200px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {this.state.converterId}
              </FormLabel>{" "}
              {/*
              <TextField
                id={`converterId${this.props.converterId}`}
                size="small"
                convertertype={this.props.convertertype}
                value={this.state.converterId}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  width: "220px",
                  input: {
                    paddingTop: "2px",
                    paddingLeft: "10px",
                    height: "29px",
                    width: "200px",
                    fontWeight: "bold",
                  },
                }}
                variant="standard"
              ></TextField>*/}
            </div>
          </div>
          <div className={`converterconfigbutton ${typeToShow}`}>
            <span
              id={`validaterename_${this.props.converterId}`}
              style={{ visibility: "hidden", color: "green" }}
              //onClick={(event) => this.ValidateRenameConverter(this.state.converterId)}
            >
              &#10003;
            </span>
            <span>{renderMuiMenuIconButton()}</span>
          </div>

          <MuiMessageBox
            // Message Box for confirm deletion
            //open="false"
            open={this.state.askingDeleteConverter}
            alertType="undefined"
            content={
              currentLocals(this.props.locale).converter.sure_to_delete + "\n" + this.state.converterId.toUpperCase()
            }
            lang="en-US"
            onClose={function noRefCheck() {}}
            primaryButton={{
              color: "primary",
              label: currentLocals(this.props.locale).converter.ConverterManagerDelete,
              onClick: () => this.OnOkDelete(),
            }}
            secondaryButtons={[
              {
                label: currentLocals(this.props.locale).converter.Cancel,
                onClick: () => this.OnCancelDelete(),
              },
            ]}
            title={currentLocals(this.props.locale).converter.ConverterManagerDelete}
          />

          <MuiMessageBox
            // warning message regarding Modaris V7 files in the Pattern Converter

            open={this.state.bShowWarningMdlV7}
            alertType="warning"
            title={currentLocals(this.props.locale).MessagesBox.ModarisV7_title}
            content={currentLocals(this.props.locale).MessagesBox.ModarisV7_content}
            lang={this.props.locale}
            onClose={function noRefCheck() {}}
            primaryButton={{
              color: "primary",
              label: currentLocals(this.props.locale).MessagesBox.ModarisV7_Button_Ok,
              onClick: () => this.OnOkDoNothing(),
            }}
            secondaryButtons={[
              {
                label: currentLocals(this.props.locale).MessagesBox.ModarisV7_Button_Not_show_again,
                onClick: () => this.OnDoNotShowAgain(),
              },
            ]}
          />

          <MuiDialog
            // Dialog for renaming
            open={this.state.askingRenameConverter}
            title={currentLocals(this.props.locale).converter.ConverterManagerRename}
            maxWidth="xs"
            //closeButtonLabel={currentLocals(this.props.locale).welcome.Close}
            //enableCloseIcon
            //open={this.state.isPreferencesPopupOpened}
            //onClose={() => this.props.setConvertersManagerOpen(false)}
          >
            <FormControl sx={{ marginBottom: 3, width: "100%" }}>
              <TextField
                id={`converterId${this.props.converterId}`}
                value={this.state.converterId}
                onChange={(event) => this.handleRename(event.target.value)}
                //onClick={(event) => this.setState({ SelectedConverterId: this.state.converterId })}
                //onBlur={(event) => this.handleOnBlur(this.state.SelectedConverterId, event.target.value, index)}

                error={this.state.error}
                helperText={this.state.helperText}
                size="small"
                convertertype={this.props.convertertype}
                InputProps={{
                  readOnly: miConverterIdReadOnly,
                }}
                sx={{ marginbotton: 2, paddingLeft: 0, width: "100%" }}
              ></TextField>
            </FormControl>

            <span style={{ float: "right" }}>
              <MuiLectraButton
                onClick={(event) => this.OnOkRename(this.state.converterId)}
                disabled={this.state.error}
                sx={{ marginLeft: 2 }}
              >
                {currentLocals(this.props.locale).converter.ConverterManagerRename}
              </MuiLectraButton>{" "}
              <MuiLectraButton onClick={(event) => this.OnCancelRename()} kind="secondary" sx={{ marginLeft: 2 }}>
                {currentLocals(this.props.locale).converter.Cancel}
              </MuiLectraButton>
            </span>
          </MuiDialog>
        </div>
        <div className={`arrowtext ${typeToShow}`} id={`arrowtext${this.props.converterId}`}>
          {ConverterDescription}
        </div>

        <div
          id={`uploadzone${this.props.converterId}`}
          className={`uploadzone  ${typeToShow}`}
          disabled
          onClick={(event) => this.handleClick(event, isMultipleMdl)}
          onDrop={(event) => this.handleDrop(event, isMultipleMdl)}
        >
          <div
            id={`uploadzoneinnerbox${this.props.converterId}`}
            className={`uploadzoneinnerbox stopped ${typeToShow}`}
          >
            <div className={`dragtext ${typeToShow}`} id={`dragtext${this.props.converterId}`}>
              {this.setDefaultConverterText()}
            </div>
          </div>
        </div>
      </Paper>
    );
  }
}
function GetRuleFile(text, file, typeGrading, arrfiles) {
  //let rulfile = null;
  let rulfilename = "";
  let textToLower = text.toLowerCase();

  let typeGradingToLower = typeGrading.toLowerCase();
  let pos = text.search(typeGrading);
  let posLowerCase = textToLower.search(typeGradingToLower);
  let posRegExp = text.search(new RegExp(typeGrading, "i"));

  if (pos == -1 && posLowerCase > 0) {
    /*In case the strings are not found in normal search,
   we search in lowercase. We don't always do it, sometimes there are differences in length between 
   characters when converting to uppercase or lowercase.  */

    pos = posRegExp;
  }
  //console.log(typeGrading);
  let rulfile = null;
  let line = text.substr(pos);
  //let line = textToLower.substr(pos);
  if (pos == -1 && typeGrading.search("Special Grade Rule") >= 0) {
    return rulfile;
  } else {
    const extension = file.name.split(".").pop();
    line = line.length > 0 ? line.substr(0, line.search("\n")) : "";
    let arrulfilename = line.length > 0 ? line.split(":") : [];
    rulfilename =
      arrulfilename.length > 0 ? arrulfilename[1].trim() + ".rul" : file.name.replace("." + extension, ".rul");
    function rulName(filename) {
      return filename.name === rulfilename;
    }
    //  the search for the file within the array must also be done considering upper and lower case

    // We proceed as alwayls
    rulfile = arrfiles[1].find(rulName);
    if (rulfile === undefined) {
      rulfilename = rulfilename.replace(".rul", ".RUL");
      rulfile = arrfiles[1].find(rulName);
    }

    /*  INICIO D-161693: Pattern convert missing grading information when dxf name has Chinese

    If we don't find any file, We do a little trick:
    If there are only two files (Condition1)
    and the extension of one is .rul (Condition2)
    and the name is the same as that of the .dxf, we consider that it is the .rul sought   (Condition3)
    */
    let cond1, cond2, cond3;

    if (arrfiles[1].length === 2) {
      // We search the indexes of dxf file and rul file
      let i = 0;
      let indexdxf = 0,
        indexrul = 0;
      while (i < arrfiles[1].length) {
        let file = arrfiles[1][i].name;
        let extension = file.substr(file.lastIndexOf(".") + 1, file.length);
        if (extension.toLowerCase() === "dxf") indexdxf = i;
        if (extension.toLowerCase() === "rul") indexrul = i;
        i++;
      }

      cond1 = true;
      let filedxf = arrfiles[1][indexdxf].name;
      let filenamedxf = filedxf.substr(0, filedxf.lastIndexOf("."));
      let filerul = arrfiles[1][indexrul].name;
      let extensionrul = filerul.substr(filerul.lastIndexOf(".") + 1, filerul.length);
      let filenamerul = filerul.substr(0, filerul.lastIndexOf("."));
      if (extensionrul.toLowerCase() === "rul") cond2 = true;
      else cond2 = false;

      if (filenamedxf === filenamerul) cond3 = true;
      else cond3 = false;

      if (cond1 && cond2 && cond3) rulfile = arrfiles[1][indexrul];
    } else cond1 = false;

    //FINAL  D-161693: Pattern convert missing grading information when dxf name has Chinese
    return rulfile;
  }
}
